export default __webpack_public_path__ + "static/media/plane2.67817627.jpg";